import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
//   withCredentials: true,  // if using session auth or CSRF
});

export default api;